const LinkSvg = ({ color }: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clipPath="url(#clip0_12954_110456)">
        <path
          d="M7.22622 0.219938L4.57422 2.87194L5.63472 3.93244L7.75572 1.81144L10.188 4.24369L8.06697 6.36469L9.12747 7.42519L11.7795 4.77319C12.0727 4.47994 12.0727 4.00594 11.7795 3.71269L8.28672 0.219938C7.99347 -0.0733125 7.51947 -0.0733125 7.22622 0.219938Z"
          fill={color ?? "#1064DB"}
        />
        <path
          d="M0.219938 7.2272L2.87194 4.5752L3.93244 5.6357L1.81144 7.7567L4.24369 10.1889L6.36469 8.06795L7.42519 9.12845L4.77319 11.7804C4.47994 12.0737 4.00594 12.0737 3.71269 11.7804L0.219938 8.2877C-0.0733125 7.99445 -0.0733125 7.52045 0.219938 7.2272Z"
          fill={color ?? "#1064DB"}
        />
        <path
          d="M4.50019 8.25019C4.30819 8.25019 4.11619 8.17669 3.96994 8.03044C3.67669 7.73719 3.67669 7.26319 3.96994 6.96994L6.96994 3.96994C7.26319 3.67669 7.73719 3.67669 8.03044 3.96994C8.32369 4.26319 8.32369 4.73719 8.03044 5.03044L5.03044 8.03044C4.88419 8.17669 4.69219 8.25019 4.50019 8.25019Z"
          fill={color ?? "#1064DB"}
        />
      </g>
    </svg>
  );
};

export default LinkSvg;
